import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/nonBilledSessionsReport-actions';
import { NonBilledSessionsReportActions } from '../constants';

export interface INonBilledSession extends Record<string, unknown> {
    id: number;
    seanceDate: string;
    startTime: string | null;
    endTime: string | null;
    provider: { id: number; fullName: string };
    student: { id: number; firstName: string; lastName: string };
    serviceType: { id: number; title: string };
    occasion: { id: number; caseNumber: string | null; caseType: number | null; orderType: number | null };
}

export interface NonBilledSessionsReportState {
    inProgress: boolean;
    error: string;
    data: Paginated<INonBilledSession>;
}

const initialState: NonBilledSessionsReportState = {
    inProgress: false,
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

export function nonBilledSessionsReport(
    state: NonBilledSessionsReportState = initialState,
    action: Actions | any,
): NonBilledSessionsReportState {
    switch (action.type) {
        case requestType(NonBilledSessionsReportActions.FETCH_NON_BILLED_SESSIONS_REPORT):
            return {
                ...state,
                data: { ...state.data, list: [], inProgress: true },
                error: '',
                inProgress: true,
            };
        case successType(NonBilledSessionsReportActions.FETCH_NON_BILLED_SESSIONS_REPORT):
            return {
                ...state,
                data: {
                    ...action.payload,
                    inProgress: false,
                },
                inProgress: false,
            };
        case failureType(NonBilledSessionsReportActions.FETCH_NON_BILLED_SESSIONS_REPORT):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };
        default:
            return state;
    }
}
